import { createAction } from 'redux-actions'
import get from 'lodash.get'
import { parse } from 'qs'

import * as types from '../Loads/actionTypes'
import * as globalTypes from '../../actions/types'
import FileService from '../../services/FileService'
import FILE_TYPES from '../../utils/fileEnums'
import { loadPagination } from '../../utils/constants'
import { fetchLoadById } from '../LoadsDetails/actions'
import history from '../../history'
import { getChannels, centrifugeStatus, startCentrifuge } from '../../actions/centrifuge'
import LoadDetailsService from '../LoadsDetails/service'
import { FIRST_FETCH_CONFIGURED_TABLE, FIRST_FETCH_UNSET_CONFIGURED_TABLE } from '../LoadTable/types'
import LoadTableService from '../LoadTable/service'

import { sectionFiltersMap } from './utils'
import LoadsService from './service'

export const fetchReceiversById = (hashId, deliveryId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  LoadDetailsService.fetchReceivers(hashId, deliveryId)
    .then((result) => {
      dispatch(createAction(types.FETCH_RECEIVERS_BY_ID)(result))
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
    .catch(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
}

export const incrementUpdates = () => (dispatch) => dispatch(createAction(types.INCREMENT_UPDATES)({}))

export const resetUpdates = () => (dispatch) => dispatch(createAction(types.SET_UPDATES)(0))

export const requestAuctionTime = () => (dispatch, state) => {
  let loadsIds = get(state(), 'loads.marketLoads', []) || []

  if (loadsIds.length) {
    loadsIds = loadsIds.filter(
      (load) =>
        load && load.shippingStatus === 'WAIT_TRANSPORTER_ACCEPT' && load.shippingType.toLowerCase() === 'auction',
    )
  }
  loadsIds = loadsIds.map((item) => item.hashId)
  const path = get(history, 'location.pathname', '')
  if (path.includes('/details')) {
    const hash = path.substr(7, path.indexOf('/details') - 7)
    loadsIds = [hash]
  }
  LoadsService.requestAuctionTime(loadsIds)
    .then(() => {})
    .catch((err) => {
      console.log(err)
    })
}

export const subscribeLoadsCentrifuge = () => (dispatch) => {
  dispatch(getChannels())
}

export const saveFilters = (params) => (dispatch) => {
  dispatch(createAction(types.SAVE_FILTERS_LOADS)(params))
}

export const fetchCountByParams =
  (
    status,
    operationGroups,
    text,
    page,
    first,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate,
    endCollectDate,
    waitingAtLogisticOperator,
    trackingStatus,
    flProposalSended,
    flShippingNotViewed,
  ) =>
    async (dispatch, state) => {
      if (!operationGroups.length) {
        operationGroups = get(state(), 'loads.filters.operationGroups', [])
      }

      try {
        const result = await LoadsService.fetchCountByParams(
          status,
          operationGroups,
          text,
          page,
          loadPagination,
          searchStatus,
          collectUF,
          deliveryUF,
          initCollectDate,
          endCollectDate,
          waitingAtLogisticOperator,
          trackingStatus,
          flProposalSended,
          flShippingNotViewed,
        )
        switch (status) {
          case 'NEGOTIATION': {
            dispatch(
              createAction(types.SET_AMOUNTS)({
                value: result,
                key: 'amountNegotiation',
              }),
            )
            return null
          }
          case 'HIRED': {
            return dispatch(
              createAction(types.SET_AMOUNTS)({
                value: result,
                key: 'amountHired',
              }),
            )
          }
          case 'IN_TRANSIT': {
            return dispatch(
              createAction(types.SET_AMOUNTS)({
                value: result,
                key: 'amountTransit',
              }),
            )
          }
          case 'DELIVERED': {
            return dispatch(
              createAction(types.SET_AMOUNTS)({
                value: result,
                key: 'amountDelivered',
              }),
            )
          }
          case 'IN_PROGRESS': {
            return dispatch(
              createAction(types.SET_AMOUNTS)({
                value: result,
                key: 'amountInProgress',
              }),
            )
          }
        }
      } catch (err) {
        console.error(err)
      } finally {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      }
    }

const COLUMNS_MAP_STATE_LABELS = {
  NEGOTIATION: 'Negotiation',
  IN_PROGRESS: 'InProgress',
  HIRED: 'Hired',
  IN_TRANSIT: 'Transit',
  DELIVERED: 'Delivered',

}

export const handleViewCounter =
  (
    status,
    operationGroups,
    text,
    page,
    size,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate,
    endCollectDate,
    waitingAtLogisticOperator,
    trackingStatus,
    flProposalSended,
    flShippingNotViewed,
    flLotAvailable,
  ) =>
    (dispatch) => {
      const loadingKey = `loadingAmount${COLUMNS_MAP_STATE_LABELS[status]}`
      const viewCounterKey = `viewAmount${COLUMNS_MAP_STATE_LABELS[status]}`
      const amountKey = `amount${COLUMNS_MAP_STATE_LABELS[status]}`
      dispatch(createAction(types.COUNT_IS_LOADING_BY_STATUS)({ key: loadingKey, value: true }))
      LoadsService.fetchCountByParams(
        status,
        operationGroups,
        text,
        page,
        size,
        searchStatus,
        collectUF,
        deliveryUF,
        initCollectDate,
        endCollectDate,
        waitingAtLogisticOperator,
        trackingStatus,
        flProposalSended,
        flShippingNotViewed,
        flLotAvailable,

      ).then((res) => {
        dispatch(createAction(types.SET_AMOUNTS)({ key: amountKey, value: res }))
        dispatch(createAction(types.VIEW_COUNT_BY_STATUS)({ key: viewCounterKey, value: true }))
      }).finally(() => dispatch(createAction(types.COUNT_IS_LOADING_BY_STATUS)({ key: loadingKey, value: false })))
    }

export const handleHiddenCount = (status) => dispatch => {
  const loadingKey = `loadingAmount${COLUMNS_MAP_STATE_LABELS[status]}`
  const viewCounterKey = `viewAmount${COLUMNS_MAP_STATE_LABELS[status]}`
  const amountKey = `amount${COLUMNS_MAP_STATE_LABELS[status]}`
  dispatch(createAction(types.SET_AMOUNTS)({ key: amountKey, value: 0 }))
  dispatch(createAction(types.VIEW_COUNT_BY_STATUS)({ key: viewCounterKey, value: false }))
  dispatch(createAction(types.COUNT_IS_LOADING_BY_STATUS)({ key: loadingKey, value: false }))
}

export const handleHiddenAllCount = () => dispatch => {
  dispatch(createAction(types.HIDDEN_ALL_COUNTERS)())
}

export const fetchLoadsWithProposal =
  (
    status,
    operationGroups,
    text,
    page,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate = '',
    endCollectDate = '',
    waitingAtLogisticOperator = '',
    trackingStatus,
    flProposalSended,
    flShippingNotViewed,
    orderBy,
  ) =>
    (dispatch, state) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))

      if (!operationGroups.length) {
        operationGroups = get(state(), 'loads.filters.operationGroups', [])
      }

      if (page === 1) {
        dispatch(
          handleHiddenAllCount(),
        )
      }

      LoadsService.fetchLoadsByParams(
        status,
        operationGroups,
        text,
        page,
        loadPagination,
        searchStatus,
        collectUF,
        deliveryUF,
        initCollectDate,
        endCollectDate,
        waitingAtLogisticOperator,
        trackingStatus,
        flProposalSended,
        flShippingNotViewed,
        orderBy,
      )
        .then((result) => {
          if (result) {
            if (status === 'NEGOTIATION' && result.length) {
              centrifugeStatus().then(async (res) => {
                if (res === 'connected') {
                  dispatch(subscribeLoadsCentrifuge(result))
                } else {
                  await dispatch(startCentrifuge(() => dispatch(subscribeLoadsCentrifuge(result))))
                }
              })
            }
          }
          const newResult =
          page === 1
            ? result.map((load) => ({
              ...load,
              lastUpdated: new Date().getTime(),
            }))
            : result

          dispatch(
            createAction(types.FETCH_MARKET_LOADS)({
              data: newResult.filter((item) => !item.hasMyAccept),
              page,
            }),
          )
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        })
    }

export const fetchLoadsByParams =
  (
    status,
    operationGroups,
    text,
    page,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate = '',
    endCollectDate = '',
    waitingAtLogisticOperator = '',
    trackingStatus,
    flProposalSended = null,
    flShippingNotViewed = null,
    orderBy = null,
    flLotAvailable,
  ) =>
    (dispatch, state) => {
      if (flProposalSended || flShippingNotViewed) {
        dispatch(
          fetchLoadsWithProposal(
            status,
            operationGroups,
            text,
            page,
            searchStatus,
            collectUF,
            deliveryUF,
            initCollectDate,
            endCollectDate,
            waitingAtLogisticOperator,
            trackingStatus,
            flProposalSended,
            flShippingNotViewed,
            orderBy,
            flLotAvailable,
          ),
        )
        return
      }
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))

      if (!operationGroups.length) {
        operationGroups = get(state(), 'loads.filters.operationGroups', [])
      }

      // if (page === 1) {
      //   dispatch(
      //     fetchCountByParams(
      //       status,
      //       operationGroups,
      //       text,
      //       page,
      //       loadPagination,
      //       searchStatus,
      //       collectUF,
      //       deliveryUF,
      //       initCollectDate,
      //       endCollectDate,
      //       waitingAtLogisticOperator,
      //       trackingStatus,
      //       flProposalSended,
      //       flShippingNotViewed,
      //       orderBy,
      //     ),
      //   )
      // }
      if (page === 1) {
        dispatch(
          handleHiddenCount(status),
        )
      }

      LoadsService.fetchLoadsByParams(
        status,
        operationGroups,
        text,
        page,
        loadPagination,
        searchStatus,
        collectUF,
        deliveryUF,
        initCollectDate,
        endCollectDate,
        waitingAtLogisticOperator,
        trackingStatus,
        flProposalSended,
        flShippingNotViewed,
        orderBy,
        flLotAvailable,
      )
        .then((result) => {
          if (result) {
            if (status === 'NEGOTIATION' && result.length) {
              centrifugeStatus().then(async (res) => {
                if (res === 'connected') {
                  dispatch(subscribeLoadsCentrifuge(result))
                } else {
                  await dispatch(startCentrifuge(() => dispatch(subscribeLoadsCentrifuge(result))))
                }
              })
            }
          }
          const newResult =
          page === 1
            ? result.map((load) => ({
              ...load,
              lastUpdated: new Date().getTime(),
            }))
            : result

          switch (status) {
            case 'NEGOTIATION': {
              dispatch(
                createAction(types.FETCH_MARKET_LOADS)({
                  data: newResult.filter((item) => !item.hasMyAccept),
                  page,
                }),
              )
              break
            }
            case 'HIRED': {
              dispatch(createAction(types.FETCH_MY_LOADS)({ data: newResult, page }))
              break
            }
            case 'IN_TRANSIT': {
              dispatch(createAction(types.FETCH_LOCKED_LOADS)({ data: newResult, page }))
              break
            }
            case 'DELIVERED': {
              dispatch(createAction(types.FETCH_CLOSED_LOADS)({ data: newResult, page }))
              break
            }
            case 'IN_PROGRESS': {
              dispatch(
                createAction(types.FETCH_IN_PROGRESS_LOADS)({
                  data: newResult,
                  page,
                }),
              )
              break
            }
            default:
              break
          }
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        })
    }

export const clearReportFile = () => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
}

export const downloadShippings =
  (status, operationGroups, text, searchStatus = [], collectUF = '', deliveryUF = '') =>
    async (dispatch, state) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))

      if (!operationGroups.length) {
        operationGroups = get(state(), 'loads.filters.operationGroups', [])
      }

      await LoadsService.downloadByParams(status, operationGroups, text, searchStatus, collectUF, deliveryUF)
        .then((file) => {
          const fileExtension = file ? file.split('.').pop() : ''
          const nameFileSplit = file ? file.split('/').pop().split('.', 1).pop() : ''
          const fileName = `${nameFileSplit}.${fileExtension}`

          console.log('fileName', fileName)
          FileService.downloadAsBlob(file).then((result) => {
            saveAs(result, fileName)
            dispatch(clearReportFile())
            dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
          })
        })
        .catch((err) => {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
          console.log(err)
        })
    }


const handleNewResults = (result) => result.map((load) => ({ ...load, lastUpdated: new Date().getTime() }))

export const fetchLoadsWithProposalSended =
  (
    operationGroups,
    search = '',
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate,
    endCollectDate,
    waitingAtLogisticOperator,
    trackingStatus,
    flProposalSended,
    flShippingNotViewed,
    orderBy,
  ) =>
    async (dispatch, state) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))

      const page = 1
      dispatch(createAction(types.SET_LIST_SCROLL)(true))
      dispatch(resetUpdates())
      dispatch(createAction(types.CLEAR_ALL_LOADS)())

      if (!operationGroups.length) {
        operationGroups = get(state(), 'loads.filters.operationGroups', [])

        if (!operationGroups.length) {
          await LoadsService.fetchOperationGroups()
            .then((result) => {
              if (result) {
                dispatch(createAction(types.OPERATION_GROUPS_LOADS)(result))
                operationGroups.push(...result.map((e) => e.id))
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }
      const params = {
        operationGroups,
        search,
        searchStatus,
        collectUF,
        deliveryUF,
        initCollectDate,
        endCollectDate,
        waitingAtLogisticOperator,
        trackingStatus,
        flProposalSended,
        flShippingNotViewed,
      }

      dispatch(saveFilters(params))
      const actions = ['NEGOTIATION']

      const promises = actions.map((action) =>
        LoadsService.fetchLoadsByParams(
          action,
          operationGroups,
          search,
          page,
          loadPagination,
          searchStatus,
          collectUF,
          deliveryUF,
          initCollectDate,
          endCollectDate,
          waitingAtLogisticOperator,
          trackingStatus,
          flProposalSended,
          flShippingNotViewed,
          orderBy,
        ),
      )
      dispatch(handleHiddenAllCount())
      Promise.all([...promises])
        .then((result) => {
          const [loads] = result

          if (loads) {
            centrifugeStatus().then(async (res) => {
              if (res === 'connected') {
                if (loads) {
                  dispatch(subscribeLoadsCentrifuge(loads))
                }
              } else {
                await dispatch(startCentrifuge(() => dispatch(subscribeLoadsCentrifuge(loads))))
              }
            })
          }
          dispatch(createAction(types.FETCH_LOAD_BY_PARAMS)(loads))
          dispatch(
            createAction(types.FETCH_MARKET_LOADS)({
              data: handleNewResults(loads.filter((item) => !item.hasMyAccept)),
              page,
            }),
          )
        // dispatch(
        //   createAction(types.SET_AMOUNTS)({
        //     value: count,
        //     key: 'amountNegotiation',
        //   }),
        // )
        })
        .finally(() => {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        })
    }

export const fetchLoadsAll =
  (
    operationGroups,
    search = '',
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate,
    endCollectDate,
    waitingAtLogisticOperator,
    trackingStatus,
    flProposalSended,
    flShippingNotViewed,
    sortingByStatus = {},
    flLotAvailable,
  ) =>
    async (dispatch, state) => {
      if (flProposalSended || flShippingNotViewed) {
        dispatch(
          fetchLoadsWithProposalSended(
            operationGroups,
            search,
            searchStatus,
            collectUF,
            deliveryUF,
            initCollectDate,
            endCollectDate,
            waitingAtLogisticOperator,
            trackingStatus,
            flProposalSended,
            flShippingNotViewed,
            sortingByStatus.negotiation,
            flLotAvailable,
          ),
        )
        return
      }
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))

      const page = 1
      dispatch(createAction(types.SET_LIST_SCROLL)(true))
      dispatch(resetUpdates())
      dispatch(createAction(types.CLEAR_ALL_LOADS)())

      if (!operationGroups.length) {
        operationGroups = get(state(), 'loads.filters.operationGroups', [])

        if (!operationGroups.length) {
          await LoadsService.fetchOperationGroups()
            .then((result) => {
              if (result) {
                dispatch(createAction(types.OPERATION_GROUPS_LOADS)(result))
                operationGroups.push(...result.map((e) => e.id))
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }

      const params = {
        operationGroups,
        search,
        searchStatus,
        collectUF,
        deliveryUF,
        initCollectDate,
        endCollectDate,
        waitingAtLogisticOperator,
        trackingStatus,
      }

      dispatch(saveFilters(params))

      const actions = ['NEGOTIATION', 'HIRED', 'IN_TRANSIT', 'IN_PROGRESS', 'DELIVERED']

      const promises = actions.map((action) =>
        LoadsService.fetchLoadsByParams(
          action,
          operationGroups,
          search,
          page,
          loadPagination,
          searchStatus,
          collectUF,
          deliveryUF,
          initCollectDate,
          endCollectDate,
          waitingAtLogisticOperator,
          trackingStatus,
          false,
          false,
          sortingByStatus[action.toLowerCase()],
          flLotAvailable,
        ),
      )
      dispatch(handleHiddenAllCount())
      // const counters = actions.map((action) =>
      //   LoadsService.fetchCountByParams(
      //     action,
      //     operationGroups,
      //     search,
      //     page,
      //     loadPagination,
      //     searchStatus,
      //     collectUF,
      //     deliveryUF,
      //     initCollectDate,
      //     endCollectDate,
      //     waitingAtLogisticOperator,
      //     trackingStatus,
      //   ),
      // )

      Promise.all([...promises])
        .then((results) => {
          const [
            negotiationLoads,
            hiredLoads,
            transitLoads,
            progressLoads,
            deliveredLoads,
          // negotiationCounter,
          // hiredCounter,
          // transitCounter,
          // progressCounter,
          // deliveredCounter,
          ] = results

          if (negotiationLoads) {
            centrifugeStatus().then(async (res) => {
              if (res === 'connected') {
                if (negotiationLoads) {
                  dispatch(subscribeLoadsCentrifuge(negotiationLoads))
                }
              } else {
                await dispatch(startCentrifuge(() => dispatch(subscribeLoadsCentrifuge(negotiationLoads))))
              }
            })
          }
          dispatch(createAction(types.FETCH_LOAD_BY_PARAMS)(negotiationLoads))
          dispatch(
            createAction(types.FETCH_MARKET_LOADS)({
              data: handleNewResults(negotiationLoads.filter((item) => !item.hasMyAccept)),
              page,
            }),
          )
          // dispatch(
          //   createAction(types.SET_AMOUNTS)({
          //     value: negotiationCounter,
          //     key: 'amountNegotiation',
          //   }),
          // )
          // dispatch(
          //   createAction(types.SET_AMOUNTS)({
          //     value: hiredCounter,
          //     key: 'amountHired',
          //   }),
          // )
          // dispatch(
          //   createAction(types.SET_AMOUNTS)({
          //     value: transitCounter,
          //     key: 'amountTransit',
          //   }),
          // )
          // dispatch(
          //   createAction(types.SET_AMOUNTS)({
          //     value: progressCounter,
          //     key: 'amountInProgress',
          //   }),
          // )
          // dispatch(
          //   createAction(types.SET_AMOUNTS)({
          //     value: deliveredCounter,
          //     key: 'amountDelivered',
          //   }),
          // )
          dispatch(
            createAction(types.FETCH_MY_LOADS)({
              data: handleNewResults(hiredLoads || []),
              page,
            }),
          )
          dispatch(
            createAction(types.FETCH_LOCKED_LOADS)({
              data: handleNewResults(transitLoads || []),
              page,
            }),
          )
          dispatch(
            createAction(types.FETCH_CLOSED_LOADS)({
              data: handleNewResults(deliveredLoads || []),
              page,
            }),
          )
          dispatch(
            createAction(types.FETCH_IN_PROGRESS_LOADS)({
              data: handleNewResults(progressLoads || []),
              page,
            }),
          )
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
    }

export const isFetchLoading = (status) => async (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(status))
}

export const fetchShippingsForGroup = (operationGroupId) => async (dispatch) => {
  LoadsService.fetchShippingsForGroup(operationGroupId).then((result) => {
    if (!!result && result.length) {
      dispatch(createAction(types.FETCH_LOAD_FOR_GROUP)(result))
    }
  })
}


export const closeLoadByTransporter = (receiptPath, hashId, refreshLoads) => (dispatch) => {
  LoadsService.markLoadAsDelivered(hashId, receiptPath)
    .then(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      if (refreshLoads) {
        dispatch(fetchLoadsByParams({ tab: 'my' }))
      } else {
        dispatch(fetchLoadById(hashId))
      }
      return dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Comprovate enviado, entrega finalizada.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }),
      )
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      console.log(err)
    })
}

export const markLoadAsDelivered = (hashId, receiptFile, refreshLoads) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  FileService.upload(receiptFile, FILE_TYPES.shipping.receipt).then((result) => {
    if (!result) {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      return dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Comprovate não foi salvo.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'error',
          messageTimestamp: new Date().getTime(),
        }),
      )
    }
    return dispatch(closeLoadByTransporter(result, hashId, refreshLoads))
  })
}

export const updateLoadListByStatus = () => (dispatch) => {
  const queryString = get(history, 'location.search', '')
  const query = parse(queryString.replace('?', ''))
  const section = query.section || 'market'
  dispatch(fetchLoadsByParams(sectionFiltersMap[section]))
}

export const updateLoadListAll = (negociation, hired, inTransit, delivered, inProgress) => (dispatch, state) => {
  const progressWith = get(state(), 'loads.filters.progressWith', false)

  if (negociation && hired && inTransit && delivered && inProgress) {
    dispatch(fetchLoadsAll([], '', progressWith))
    return
  }
  if (negociation) {
    dispatch(fetchLoadsByParams('NEGOTIATION', [], '', 1, true))
  }
  if (hired && !progressWith) {
    dispatch(fetchLoadsByParams('HIRED', [], '', 1, true))
  }
  if (inTransit && !progressWith) {
    dispatch(fetchLoadsByParams('IN_TRANSIT', [], '', 1, true))
  }
  if (inProgress && progressWith) {
    dispatch(fetchLoadsByParams('IN_PROGRESS', [], '', 1, true))
  }
  if (delivered) {
    dispatch(fetchLoadsByParams('DELIVERED', [], '', 1, true))
  }
}

export const fetchConfiguredTable = () => (dispatch) => {
  const status = {
    NEGOTIATION: 'NEGOTIATION',
    IN_PROGRESS: 'IN_PROGRESS',
    DELIVERED: 'DELIVERED',
  }
  const datas = {
    NEGOTIATION: '',
    IN_PROGRESS: '',
    DELIVERED: '',
  }
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  LoadTableService.fetchConfiguredTable(status.NEGOTIATION)
    .then((result) => {
      if (result) {
        datas.NEGOTIATION = result
        return LoadTableService.fetchConfiguredTable(status.IN_PROGRESS)
      }
    })
    .then((result) => {
      if (result) {
        datas.IN_PROGRESS = result
        return LoadTableService.fetchConfiguredTable(status.DELIVERED)
      }
    })
    .then((result) => {
      if (result) {
        datas.DELIVERED = result
        dispatch(createAction(FIRST_FETCH_CONFIGURED_TABLE)({ config: datas }))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
}

// Compatibility export: older code expects `setConfiguredTable`.
export const setConfiguredTable = () => (dispatch) => dispatch(fetchConfiguredTable())

export const fetchUnsetConfiguredTable = () => (dispatch) => {
  const status = {
    NEGOTIATION: 'NEGOTIATION',
    IN_PROGRESS: 'IN_PROGRESS',
    DELIVERED: 'DELIVERED',
  }
  const datas = {
    NEGOTIATION: '',
    IN_PROGRESS: '',
    DELIVERED: '',
  }
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  LoadTableService.fetchUnsetConfiguredTable(status.NEGOTIATION)
    .then((result) => {
      if (result) {
        datas.NEGOTIATION = result
        return LoadTableService.fetchUnsetConfiguredTable(status.IN_PROGRESS)
      }
    })
    .then((result) => {
      if (result) {
        datas.IN_PROGRESS = result
        return LoadTableService.fetchUnsetConfiguredTable(status.DELIVERED)
      }
    })
    .then((result) => {
      if (result) {
        datas.DELIVERED = result
        dispatch(createAction(FIRST_FETCH_UNSET_CONFIGURED_TABLE)({ config: datas }))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
}


export const groupShippings = (deliveryIds) => async (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  LoadsService.groupShippings(deliveryIds)
    .then(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
    .catch(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
}
